import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMicrosoftsharepointComponent } from './simple-icons-microsoftsharepoint.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMicrosoftsharepointComponent ],
    exports:      [ SimpleIconsMicrosoftsharepointComponent ],
    bootstrap:    []
})
export class SimpleIconsMicrosoftsharepointModule {}
